import React from 'react'
import { JSONEditor } from '@json-editor/json-editor'

interface SchemaJsonEditorProps {
  value?: any
  options?: any
  onChange?: (value: string) => void
  onError?: (error: any) => void
  onDirty?: () => void
  className?: string
  style?: React.CSSProperties
}

interface SchemaJsonEditorState {
  dirty: boolean
  controllingFocus?: boolean
}

class SchemaJsonEditor extends React.PureComponent<SchemaJsonEditorProps, SchemaJsonEditorState> {
  timeout: NodeJS.Timeout | undefined = undefined

  editor: any = null

  div: HTMLDivElement | null = null

  constructor(props: SchemaJsonEditorProps) {
    super(props)
    this.state = {
      dirty: false,
    }
  }

  componentDidMount(): void {
    const { value, options } = this.props

    const opts = {
      ...options,
    }

    if (opts.schema == null) {
      opts.schema = {}
    }

    if (opts.theme == null) {
      opts.theme = 'bootstrap4'
    }

    const mergedOptions = {
      ...opts,
      // onChange: this.handleChange,
      // onValidationError: this.handleError,
    }

    this.editor = new JSONEditor(this.div, mergedOptions)

    this.setValue(value)

    this.editor.on('change', (e: any) => {
      console.log('e : ', e)
      this.handleChange()
    })
  }

  componentDidUpdate(prevProps: SchemaJsonEditorProps): void {
    const { onDirty, value } = this.props
    const { dirty, controllingFocus } = this.state

    if (dirty === true && controllingFocus && onDirty) {
      onDirty()
    }

    if (dirty === true && !controllingFocus) {
      this.timeout = setTimeout(() => {
        this.setState({
          dirty: false,
        })
      }, 100)
    }

    if (controllingFocus) {
      clearTimeout(this.timeout)
    }

    if (prevProps.value !== value) {
      this.setValue(value)
      setTimeout(() => {
        this.setState({
          dirty: false,
        })
      }, 1)
    }
  }

  componentWillUnmount(): void {
    if (this.editor) {
      this.editor.destroy()
      delete this.editor
    }
    clearTimeout(this.timeout)
  }

  setValue = (value: any): void => {
    if (value != null) {
      if (typeof value === 'string') {
        const obj = JSON.parse(value)
        this.editor.setValue(obj)
      } else {
        this.editor.setValue(value)
      }
    } else {
      this.editor.setValue({})
    }
    if (this.div != null) {
      ;(this.div as any).value = value
      this.div.setAttribute('value', value)
    }
  }

  getValue = (): string => {
    const vObj = this.editor.getValue()
    const val = JSON.stringify(vObj)
    if (this.div != null) {
      ;(this.div as any).value = val
      this.div.setAttribute('value', val)
    }
    return val
  }

  handleChange = (): void => {
    const { onChange } = this.props

    const value = this.getValue()

    // console.log('validate : ', this.editor.validate())

    if (onChange != null) {
      onChange(value)
    }
    if (this.div != null) {
      ;(this.div as any).value = value
      this.div.setAttribute('value', value)
    }
  }

  handleFocus = (): void => {
    this.setState({
      controllingFocus: true,
    })
  }

  handleBlur = (): void => {
    this.setState({
      controllingFocus: false,
    })
  }

  handleError = (e: any): void => {
    const { onError } = this.props

    console.log('handleError : ', e)

    if (onError != null) {
      onError({
        hasError: e.length > 0,
        errors: e,
      })
    }
  }

  render(): React.ReactNode {
    const { className, style } = this.props

    return (
      <div
        onFocus={this.handleFocus}
        onBlur={this.handleBlur}
        className={className}
        style={style}
        ref={(div) => {
          this.div = div
        }}
      />
    )
  }
}

export default SchemaJsonEditor
